/**
 * State component for filtering entries.
 * @param {object} initialState - The initial state.
 * @returns {object} The state component.
 */
export default function state(initialState = {}) {
	return {
		selectedCategories: initialState.categories || [],
		selectedTopics: initialState.topics || [],
		selectedIndustries: initialState.industries || [],
		searchTerm: initialState.search || "",

		toggleFilter(arrayName, id) {
			const index = this[arrayName].indexOf(id);
			if (index === -1) this[arrayName].push(id);
			else this[arrayName].splice(index, 1);
		},

		resetState() {
			this.selectedCategories = [];
			this.selectedTopics = [];
			this.selectedIndustries = [];
			this.searchTerm = "";
		},
	};
}
